import { MARKET_DATA_STATS } from '@src/tokens/tooltips';
import {
  getTypedKeys,
  Table,
  TableSize,
  Tbody,
  Td,
  Text,
  Th,
  Tooltip,
  Tr,
  useMarketDataStatistics,
  useMarketsContext,
  useSecurity,
  type Market,
  type TableProps,
} from '@talos/kyoko';
import { useEffect, useState } from 'react';
import { FormatValue } from './FormatValue';
import { BLACKLISTED_KEYS } from './consts';
import { StatsWrapper } from './styles';
import { prettify } from './utils';

export interface ContractDetailsProps {
  symbol: string;
  selectedMarketAccounts: string[];
  tag: string;
}
export const ContractDetails = ({ symbol, selectedMarketAccounts, tag, size }: ContractDetailsProps & TableProps) => {
  const security = useSecurity(symbol);
  const { marketsByName } = useMarketsContext();

  const [selectedMarkets, setSelectedMarkets] = useState<string[]>([]);
  useEffect(() => {
    setSelectedMarkets(
      selectedMarketAccounts
        .map(maName => marketsByName.get(maName))
        .filter<Market>((maybeMarket): maybeMarket is Market => maybeMarket !== undefined)
        .map<string>(market => market.Name)
    );
  }, [selectedMarketAccounts, marketsByName]);

  const { marketDataStatistics } = useMarketDataStatistics(symbol, selectedMarkets, tag);

  if (!marketDataStatistics || !security) {
    return <Text color="colorTextSubtle">Details Unavailable</Text>;
  }

  return (
    <StatsWrapper>
      <Table size={size || TableSize.Small}>
        <Tbody>
          {/* TODO: check keys against actual enums to improve type-safety, or highlight type-wise if it's impossible */}
          {getTypedKeys(marketDataStatistics).map(key => {
            return (
              !BLACKLISTED_KEYS.includes(key) && (
                <Tr key={key}>
                  <Th>
                    {MARKET_DATA_STATS[key] ? (
                      <Tooltip tooltip={MARKET_DATA_STATS[key]}>{prettify(key)}</Tooltip>
                    ) : (
                      prettify(key)
                    )}
                  </Th>
                  <Td align="right">
                    <FormatValue {...{ marketDataStatistics, marketDataKey: key, security, marketsByName }} />
                  </Td>
                </Tr>
              )
            );
          })}
        </Tbody>
      </Table>
    </StatsWrapper>
  );
};
